import { useAuth } from "@babackapp/auth-client/hooks";

// Mirrors the isMerchant check in components/layout.tsx (used there to gate the
// merchant-only PositionSelector): a logged-in baback-office user, or the
// `?advanced=true` debug flag, both used for merchant preview of the widget.
export function useIsMerchant(): boolean {
  const { user } = useAuth();
  const isAdvanced = new URLSearchParams(window.location.search).get("advanced") === "true";
  return !!user || isAdvanced;
}
